module.exports = {
      id: "default-author-image-usage",
      viewBox: "0 0 48 48",
      url: "/" + "sprite-79b777a110ad18271a4fc79289e4208e.svg#default-author-image",
      toString: function () {
        return this.url;
      }
    }